export default "__VITE_ASSET__Cox4cGcV__"